import { Label, SemanticSIZES } from 'semantic-ui-react'
import './LabelTag.scss'
import {
  SubscriptionType,
  SubscriptionTypes
} from '../../../../service/Product/ProductService'

interface Props {
  text: string
  pillType?: SubscriptionTypes
  size: SemanticSIZES
}

export const LabelTag = ({ text, pillType, size }: Props): JSX.Element => (
  <div
    className={`
      ${pillType === SubscriptionType.PREMIUM && 'PremiumType'}
      ${pillType === SubscriptionType.BASIC && 'BasicType'}
      ${pillType === SubscriptionType.FREE && 'FreeType'}`}
  >
    <Label tag size={size}>
      {text}
    </Label>
  </div>
)
